/* import { createApp, computed } from "vue";
import App from "./App.vue";
import router from "./router";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";

// 解决ResizeObserver loop completed with undelivered notifications错误
if (typeof ResizeObserver !== "undefined") {
  const originalObserve = ResizeObserver.prototype.observe;
  ResizeObserver.prototype.observe = function (target) {
    try {
      originalObserve.call(this, target);
    } catch (e) {
      console.warn("ResizeObserver error:", e);
    }
  };
}

// 获取Cookie
function getCookie(name) {
  const cookieValue = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`));
  return cookieValue ? cookieValue.split("=")[1] : null;
}

// 设置Cookie
function setCookie(name, value, days = 7) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
// app.vue写在script里面  main.js写在app挂载完之后
const debounce = (fn, delay) => {
  let timer;
  return (...args) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn(...args);
    }, delay);
  };
};
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 200);
    super(callback);
  }
};

// 提供全局 token 管理
app.provide(
  "token",
  computed(() => getCookie("token")),
);
app.provide("setToken", (value) => setCookie("token", value));
app.provide("removeToken", () => setCookie("token", "", -1));

// 明确关闭严格模式
app.config.performance = false;
app.config.strict = false;

app
  .use(router)
  .use(ElementPlus, {
    locale: zhCn,
  })
  .mount("#app"); */
import { createApp, computed } from "vue";
import App from "./App.vue";
import router from "./router";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";

// 获取Cookie
function getCookie(name) {
  const cookieValue = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`));
  return cookieValue ? cookieValue.split("=")[1] : null;
}

// 设置Cookie
function setCookie(name, value, days = 7) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

const app = createApp(App);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.provide(
  "token",
  computed(() => getCookie("token"))
);
app.provide("setToken", (value) => setCookie("token", value));
app.provide("removeToken", () => setCookie("token", "", -1));

app.config.performance = false;

app
  .use(router)
  .use(ElementPlus, {
    locale: zhCn,
  })
  .mount("#app");
